// extracted by mini-css-extract-plugin
export default {"WelcomeBack":"styles_WelcomeBack__ioXiG"};